/** Knowledge's subtabs (CT-5717), child routes: `knowledge/drive`, `knowledge/sandbox`, `knowledge/truth`. */
export const KNOWLEDGE_SUBTABS = Object.freeze(['drive', 'sandbox', 'truth']);
export const DEFAULT_KNOWLEDGE_SUBTAB = 'drive';

/** The folder in view lives in the URL (`knowledge/drive?folder=<id>`), so Back returns to the parent. */
export const DRIVE_FOLDER_PARAM = 'folder';
export const DRIVE_ROOT_ID = 'root';

/** Drive chips, in the prototype's order. */
export const DRIVE_QUICK_FILTERS = Object.freeze(['all', 'recordings', 'canon', 'with_claims', 'not_read']);

/** The one order the prototype offers. */
export const DRIVE_SORT_FIELD = 'occurred_at';
export const DRIVE_SORT_DIRECTION = 'desc';
export const DRIVE_SEARCH_FIELDS = Object.freeze(['name', 'source_line']);

/** All filters: where to search, and the file types. "Created by" options arrive with the rows. */
export const DRIVE_SCOPES = Object.freeze(['folder', 'everywhere']);
export const DRIVE_TYPES = Object.freeze(['pdf', 'doc', 'sheet', 'txt']);

/** The `Chip` variant of each file status; an unknown one reads as neutral. */
export const DRIVE_STATUS_VARIANTS = Object.freeze({
  live: 'success',
  moved: 'neutral',
  linked: 'informative',
  recording: 'purple',
  meeting_record: 'informative',
  email: 'neutral',
  note: 'neutral',
  concierge: 'purple',
  workflow: 'purple',
  canon: 'success',
});

/** Said, Documented, Observed — how a claim (Sandbox) or a fact (Truth) was sourced; `knowledge.sourceTypes.*`. */
export const KNOWLEDGE_SOURCE_TYPES = Object.freeze(['said', 'documented', 'observed']);

/** The `?source=<fileId>` the Sandbox reads as its Source filter (CT-5718) — one param, both ends. */
export const SANDBOX_SOURCE_PARAM = 'source';

/** Where "View claims" lands: Sandbox filtered by the file as source (CT-5718). */
export const DRIVE_CLAIMS_SUBTAB = 'sandbox';
export const DRIVE_CLAIMS_SOURCE_PARAM = SANDBOX_SOURCE_PARAM;
export const DRIVE_PAGE_SIZE_OPTIONS = Object.freeze([10, 20, 50]);

/** Sandbox (CT-5718): chips, source types and what a search covers. */
export const SANDBOX_QUICK_FILTERS = Object.freeze(['all', 'to_confirm', 'conflicts', 'inferred']);
export const SANDBOX_SEARCH_FIELDS = Object.freeze(['label', 'value', 'quote', 'speaker']);

/** The prototype's orders: Most recent (default, newest first), Most claims, Conflicts first. */
export const SANDBOX_SORTS = Object.freeze(['occurred_at', 'claim_count', 'conflicts']);
export const SANDBOX_SORT_FIELD = 'occurred_at';
export const SANDBOX_SORT_DIRECTION = 'desc';

/** The `Badge` variant of each claim status. */
export const CLAIM_STATUS_VARIANTS = Object.freeze({
  to_confirm: 'informative',
  confirmed: 'success',
  conflict: 'error',
  inferred: 'purple',
});

/** Truth (CT-5719): the chips, what a search covers, and its one sort. The server sends the sections in order. */
export const TRUTH_QUICK_FILTERS = Object.freeze(['all', 'to_reconfirm', 'confirmed_by_me']);
export const TRUTH_SEARCH_FIELDS = Object.freeze(['label', 'value', 'source_line']);
export const TRUTH_SORT = 'needs_attention';
/** "Needs attention first" starts descending (↓, as in the prototype); the toggle puts it last. */
export const TRUTH_SORT_DIRECTION = 'desc';
/** All filters › Status: the statuses a fact has (the prototype's "Pending review" has no data yet). */
export const TRUTH_STATUSES = Object.freeze(['confirmed', 'reconfirm_due']);
